export interface TPhotoItem {
  id: string;
  file_path: string;
  taken_at: string | null;
}

export interface TAssetPhotoContext {
  asset_no: string;
  asset_name: string;
  company_code: string;
  company_name: string;
  store_code: string;
  store_name: string;
}

export const MOCK_ASSET_PHOTO: TAssetPhotoContext = {
  asset_no: '20527-001',
  asset_name: '青葉センター向け店舗支援カメラ',
  company_code: 'SM',
  company_name: 'サンプル商事',
  store_code: '002',
  store_name: '明智店',
};

export const MOCK_PHOTOS: TPhotoItem[] = [
  { id: '1', file_path: 'https://picsum.photos/seed/photo1/800/600', taken_at: '2024-10-01' },
  { id: '2', file_path: 'https://picsum.photos/seed/photo2/800/600', taken_at: '2024-09-15' },
  { id: '3', file_path: 'https://picsum.photos/seed/photo3/800/600', taken_at: '2024-08-20' },
];

export const ASSET_PHOTO_CONSTANT = {
  TITLE: {
    PAGE: '固定資産写真照会',
    BTN_BACK: '← 戻る',
    BTN_BACK_LABEL: '戻る',
    BTN_CLOSE: '閉じる',
    BTN_PREV: '◀ 前へ',
    BTN_NEXT: '次へ ▶',
    PHOTO_COUNT_UNIT: '件',
    ENLARGE_DIALOG_TITLE: '写真拡大',
  },
  LABEL: {
    ASSET_INFO_SECTION: '資産情報',
    ASSET_NO: '資産番号',
    ASSET_NAME: '資産名称',
    COMPANY: '会社',
    STORE: '店舗',
    TAKEN_AT: '撮影日',
    PHOTO_COUNT: '写真件数',
  },
  MESSAGE: {
    I01: '写真データがありません。',
    E01: '写真データの取得に失敗しました。再度お試しください。',
    E02: '画像を読み込めません。',
    E03: 'システムエラーが発生しました。管理者にお問い合わせください。',
  },
};
